export const selectAgreementLink = (state) => state.common.agreementLink;
